import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class SixwtwohService {

  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) {
  }

  getSixWTwoH(headerId: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.get<any[]>(this.baseUrl + 'find-six-w-two-h', { headers: header, params: { headerId: headerId } });
    return this.http.get<any[]>(this.O3CoreApiUrl + 'AT6W2H/ShowSixWTwoH', { headers: header, params: { headerId: headerId } });
  }

  addSixWTwoh(data: any): Observable<any[]> {
    console.log('datadata', data);
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.post<any[]>(this.baseUrl + 'add-six-w-two-h', data, { headers: header });
    return this.http.post<any[]>(this.O3CoreApiUrl + 'AT6W2H/addSixWTwoH', data, { headers: header });
  }

  updateSixWTwoh(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.put<any[]>(this.baseUrl + 'update-six-w-two-h/', data, { headers: header });
   return this.http.put<any[]>(this.O3CoreApiUrl + 'AT6W2H/updateSixTwoH', data, { headers: header });
  }

}
